const getElementComputedStyle = (element: Element): CSSStyleDeclaration =>
  window.getComputedStyle(element);

/**
 * Get an element's computed height in pixels.
 */
export const getElementComputedHeight = (element: Element): number =>
  Number(getElementComputedStyle(element).height.replace('px', ''));
